/**
 * @generated SignedSource<<3c00cc8346ef181e9e89882bc455ef8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useQuickViewCategory_quickViewCategorySegments$data = {
  readonly origin: string | null;
  readonly period: string | null;
  readonly periodPrefix: string | null;
  readonly style: string | null;
  readonly " $fragmentType": "useQuickViewCategory_quickViewCategorySegments";
};
export type useQuickViewCategory_quickViewCategorySegments$key = {
  readonly " $data"?: useQuickViewCategory_quickViewCategorySegments$data;
  readonly " $fragmentSpreads": FragmentRefs<"useQuickViewCategory_quickViewCategorySegments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useQuickViewCategory_quickViewCategorySegments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "origin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodPrefix",
      "storageKey": null
    }
  ],
  "type": "QuickViewCategorySegments",
  "abstractKey": null
};

(node as any).hash = "7e7a64c6b2cfa92450b25ca9c10bf568";

export default node;
